"use client";

import { Profile } from "@/schema/db";
import { Session } from "next-auth";
import { useCallback, useEffect } from "react";

type Primative = string | number | boolean | null | undefined;
export type UmamiTrack = (
  name: string,
  data?: Record<string, Primative>
) => Promise<void>;
export type UmamiIdentify = () => Promise<void>;

declare global {
  interface Window {
    umami?: {
      track: (name: string, data?: Record<string, Primative>) => Promise<void>;
      identify: (id: number, data: Profile) => Promise<void>;
    } | null;
  }
}

export function useUmami(session?: Session | null): UmamiTrack {
  const identify: UmamiIdentify = useCallback(async () => {
    if (!window?.umami) {
      console.warn("umami not found, skipped identify event");
    } else if (!session) {
      console.warn("session not found, skipped identify event");
    } else {
      await window?.umami.identify(
        session.user.activeProfile.id,
        session.user.activeProfile
      );
    }
  }, [session]);

  useEffect(() => {
    identify();
  }, [identify]);

  const track: UmamiTrack = useCallback(async (name, data) => {
    if (!window?.umami) {
      console.warn("umami not found, skipped track event");
    } else if (!name) {
      console.warn("no data, skipped track event");
    } else if (data) {
      await window.umami.track(name, data);
    } else {
      await window.umami.track(name);
    }
  }, []);

  return track;
}
